/**
 * Название свойства формы.
 */
export enum Field {
  /**
   * Поле ввода кода подтверждения.
   */
  CODE = 'confirmationCode',
}
